import { ModulesConfigMap, ModulesMap } from '../data/modulesMaps'

export default {
	getEvents: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EVENTS].GET_EVENTS,
	},
	getEvent: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EVENTS].GET_EVENT,
	},
	getEventPreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EVENTS].GET_EVENT_PREVIEW,
	},
	patchEvent: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EVENTS].PATCH_EVENT,
	},
}
